import React from "react";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/outline";

export default function NewsPagination({
  currentPage,
  totalPages,
  onPageChange,
}) {
  if (totalPages <= 1) return null;

  const pages = [];
  for (let i = 1; i <= totalPages; i++) pages.push(i);

  return (
    <div className="flex items-center justify-center gap-2 mt-10 select-none">
      {/* Previous */}
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className={`p-2 rounded-full border border-[#FFD76A] bg-white shadow-sm
          disabled:opacity-40 disabled:cursor-not-allowed
          hover:bg-[#FFF3AF] transition`}
      >
        <ChevronLeftIcon className="h-5 w-5 text-[#3a3a3a]" />
      </button>

      {/* Pages */}
      {pages.map((p) => (
        <button
          key={p}
          onClick={() => onPageChange(p)}
          className={`px-4 py-2 rounded-full border text-sm font-medium shadow-sm transition
            ${
              p === currentPage
                ? "bg-[#FFD76A] border-[#FFD76A] text-[#3a3a3a]"
                : "bg-white border-[#FFD76A] text-[#3a3a3a] hover:bg-[#FFF3AF]"
            }`}
        >
          {p}
        </button>
      ))}

      {/* Next */}
      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className={`p-2 rounded-full border border-[#FFD76A] bg-white shadow-sm
          disabled:opacity-40 disabled:cursor-not-allowed
          hover:bg-[#FFF3AF] transition`}
      >
        <ChevronRightIcon className="h-5 w-5 text-[#3a3a3a]" />
      </button>
    </div>
  );
}
